import { bearerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const apify = defineConnector({
  identifier: "apify",
  name: "Apify",
  tagLine: "Web scraping and automation platform",
  logo,
  protocol: "http",
  tags: ["engineering", "data", "productivity"],
  defaultUrlPattern: () => "https://api\\.apify\\.com/.*",
  auth: (app) => bearerAuth(app.secret.apiKey),
  steps: [
    {
      title: "Find your Apify API credentials",
      items: [
        {
          kind: "markdown",
          content:
            "Open [Apify account integrations](https://console.apify.com/settings/integrations) and create or copy an API token. Use a token with access to the actors, datasets, or tasks you want this connection to manage.",
        },
      ],
    },
    {
      title: "Enter your API credentials",
      items: [
        {
          kind: "markdown",
          content:
            "Enter the API credentials from your Apify account settings.",
        },
        {
          kind: "input",
          label: "API token",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
          placeholder: "apify_api_***************************nt4w",
          helperText: "The API token for your Apify account",
        },
      ],
    },
  ],
  connectionTest: { protocol: "http", request: () => "https://api.apify.com/" },
});
